import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.gv = languageMap.dot = bracketIndenting()
